module.exports = __webpack_public_path__ + "img/9788982739460.e19bbf3d.jpg";